import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import * as Constant from '../Constant';

const NewBanner = ({ slideData }) => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isTransitioning, setIsTransitioning] = useState(true);
    const sliderRef = useRef(null);

    const totalSlides = slideData.length;

    // Logic untuk berpindah slide secara otomatis
    useEffect(() => {
        const interval = setInterval(() => {
            nextSlide();
        }, 3000); // Setiap 3 detik
        return () => clearInterval(interval);
    }, [currentIndex]);

    const nextSlide = () => {
        if (currentIndex < totalSlides) {
            setCurrentIndex(currentIndex + 1);
        } else {
            // Matikan transisi sementara dan reset ke slide pertama
            setIsTransitioning(false);
            setCurrentIndex(0);
        }
    };

    // Reset posisi slider setelah transisi ke salinan slide pertama
    useEffect(() => {
        if (!isTransitioning && currentIndex === 0) {
            const timeout = setTimeout(() => {
                setIsTransitioning(true);
            }, 50); // Tunggu sebentar sebelum mengaktifkan kembali transisi
            return () => clearTimeout(timeout);
        }
    }, [isTransitioning, currentIndex]);

    const styles = {
        container: {
            position: 'relative',
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
        },
        wrapper: {
            position: 'relative',
            width: '100%',
            maxWidth: '1200px',
            overflow: 'hidden',
        },
        track: {
            display: 'flex',
            transition: isTransitioning ? 'transform 1s ease-in-out' : 'none',
            transform: `translateX(-${currentIndex * 100}%)`,
        },
        slide: {
            minWidth: '100%',
            boxSizing: 'border-box',
            padding: '0 2rem',
        },
        image: {
            width: '100%',
            height: 'auto',
            borderRadius: '0.5rem',
        },
        dotsContainer: {
            position: 'absolute',
            bottom: '-10px',
            zIndex: 10,
            display: 'flex',
            justifyContent: 'center',
            width: '100%',
            marginBottom: '10px',
        },
        dot: (isActive) => ({
            width: '8px',
            height: '8px',
            borderRadius: '50%',
            margin: '0 5px',
            backgroundColor: isActive ? '#EA6123' : '#bbb',
            cursor: 'pointer',
            transition: 'background-color 0.3s ease',
        }),
    };

    return (
        <div style={styles.container}>
            <div style={styles.wrapper}>
                <div
                    ref={sliderRef}
                    style={styles.track}
                >
                    {/* Slide Content + Duplicate Slide */}
                    {[...slideData, slideData[0]].map((val, i) => (
                        <Link to={val.link} key={i} style={styles.slide}>
                            <div className="caption round-medium shadow-large bottom-20">
                                <img
                                    style={styles.image}
                                    src={`${Constant.BASE_URL_WEB}/admin/assets/media/slider/245/${val.gambar}`}
                                    alt={`slide-${i}`}
                                />
                            </div>
                        </Link>
                    ))}
                </div>

                {/* Dots Navigation */}
                <div style={styles.dotsContainer}>
                    {slideData.map((_, index) => (
                        <button
                            key={index}
                            style={styles.dot(currentIndex % totalSlides === index)}
                            onClick={() => setCurrentIndex(index)}
                        ></button>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default NewBanner;
